export const transformDate = (dateResponse: string) => {
  const date = new Date(dateResponse);

  const localTime = date.toLocaleTimeString('ru-RU', {
    hour: '2-digit',
    minute: '2-digit',
  }); // "12:53"
  const localDate = date.toLocaleDateString(); // "26.11.2025"
  return { date: localDate, time: localTime };
};
